import * as React from 'react';
import { Box, IconButton, InputBase } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

type HeaderSearchProps = {
  value: string;
  onChange: (v: string) => void;
  onSubmit?: () => void;
  onFocus?: () => void;
  placeholder?: string;
  width?: number | string;
  autoFocus?: boolean;
};

export default function HeaderSearch({
  value,
  onChange,
  onSubmit,
  onFocus,
  placeholder = 'Поиск…',
  width = 360,
  autoFocus = false,
}: HeaderSearchProps) {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') onSubmit?.();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        width: { xs: '100%', sm: width },
        maxWidth: '100%',
        px: 1.5,
        py: 0.5,
        borderRadius: 999,
        border: '1px solid',
        borderColor: 'rgba(0,0,0,0.12)',
        bgcolor: '#fff',
        '&:hover': { bgcolor: '#fff' },
      }}
    >
      <IconButton size="small" onClick={onSubmit} aria-label="search">
        <SearchIcon />
      </IconButton>

      <InputBase
        autoFocus={autoFocus}
        value={value}
        onChange={e => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        onFocus={onFocus}
        placeholder={placeholder}
        inputProps={{ 'aria-label': 'search input' }}
        sx={{ width: '100%' }}
      />
    </Box>
  );
}
